module.exports = __webpack_public_path__ + "img/iphone-charging-SWEDEN-sv.0ed3ff9e.png";